import { render, staticRenderFns } from "./AudienceTab.vue?vue&type=template&id=433a51c0&scoped=true&"
import script from "./AudienceTab.vue?vue&type=script&lang=js&"
export * from "./AudienceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433a51c0",
  null
  
)

export default component.exports